import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import InAppMessage from "./in-app-message.js";
import u from "../../managers/subscription-manager.js";
var InAppMessageButton = /*#__PURE__*/function () {
  function InAppMessageButton(s, t, i, r, h, e, n) {
    _classCallCheck(this, InAppMessageButton);
    this.text = s, this.backgroundColor = t, this.textColor = i, this.borderColor = r, this.clickAction = h, this.uri = e, this.id = n, this.text = s || "", this.backgroundColor = t || InAppMessage.th.sh, this.textColor = i || InAppMessage.th.ih, this.borderColor = r || this.backgroundColor, this.clickAction = h || InAppMessage.ClickAction.NONE, this.uri = e, null == n && (n = InAppMessageButton.Hi), this.id = n, this.Co = !1, this.ti = new u();
  }
  _createClass(InAppMessageButton, [{
    key: "subscribeToClickedEvent",
    value: function subscribeToClickedEvent(s) {
      return this.ti.wt(s);
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(s) {
      this.ti.removeSubscription(s);
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this.ti.removeAllSubscriptions();
    }
  }, {
    key: "$t",
    value: function $t() {
      return !this.Co && (this.Co = !0, this.ti.L(), !0);
    }
  }], [{
    key: "fromJson",
    value: function fromJson(s) {
      return new InAppMessageButton(s.text, s.bg_color, s.text_color, s.border_color, s.click_action, s.uri, s.id);
    }
  }]);
  return InAppMessageButton;
}();
export { InAppMessageButton as default };
InAppMessageButton.Hi = -1;